import { StorageService } from "services/storage/storage.service"

export class User {
    Username?: string
    Enabled?: boolean
    Id?: string
    Locale?: string
    Email?: string
    FirstName?: string
    LastName?: string
    Admin?: boolean
    Status?: string

    public static fromCognitoUser(cognitoUser: any): User {
        const returnValue: User = new User()
        returnValue.Id = cognitoUser?.signInUserSession?.idToken.payload.sub
            ?? cognitoUser?.attributes?.sub
            ?? cognitoUser?.signInUserSession?.accessToken?.payload.sub

        returnValue.Username = cognitoUser.username
            ?? cognitoUser?.signInUserSession?.idToken.payload["cognito:username"]
            ?? cognitoUser?.signInUserSession?.accessToken?.payload?.username

        returnValue.Email = cognitoUser?.signInUserSession?.idToken?.payload?.email
            ?? cognitoUser?.attributes?.email

        returnValue.Locale = cognitoUser?.signInUserSession?.idToken?.payload?.locale
            ?? cognitoUser?.attributes?.locale

        returnValue.Admin = !!cognitoUser?.signInUserSession?.idToken?.payload?.admin && cognitoUser.signInUserSession.idToken.payload.admin === 'role'

        return returnValue
    }

    public static fromStorage(): User {
        return User.fromCognitoUser(StorageService.CognitoUser)
    }
}
